import {
  Link,
  useLoaderData,
} from "@remix-run/react";
import clsx from "clsx";
import { m } from "framer-motion";
import UserIcon from "~/components/Common/UserIcon";
import UserSnsList from "~/components/User/UserSnsList";
import PostActionList from "~/components/Post/PostActionList";
import { isNeverSns } from "~/database/user.model";
import { convertName } from "~/utils/convertName";
import { easeUse } from "~/utils/easingUse";
import { FunctionComponent } from "react";
import { loader } from "./route";

interface PostBottomStickyProps {
  bottomInview: boolean;
}

export const PostBottomSticky: FunctionComponent<
  PostBottomStickyProps
> = ({ bottomInview }) => {
  const { post } = useLoaderData<typeof loader>();

  return (
    <m.div
      className={clsx("py-10", "bg-white")}
      animate={{
        y: bottomInview ? 0 : "100%",
      }}
      initial={false}
      transition={{
        ...easeUse("easeOutQuint", {
          duration: 0.8,
        }),
      }}
      style={{
        position: "sticky",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2,
      }}
    >
      <div
        className={clsx(
          "mx-auto",
          "w-1305",
          "flex",
          "gap-40",
          "max-md:grid",
          "max-md:grid-cols-[auto_1fr]",
          "items-center",
          "justify-between",
          "max-md:w-360",
          "max-md:flex-row-reverse",
          "max-md:gap-20",
          "max-md:items-center",
        )}
      >
        <div
          className={clsx(
            "w-71",
            "mx-auto",
            "sp_only",
          )}
        >
          <Link to={`/user/${post.user_id}`}>
            <UserIcon
              iconPath={post.user.iconurl ?? ""}
            />
          </Link>
        </div>

        <div
          className={clsx(
            "flex",
            "items-end",
            "gap-50",
            "max-md:flex-col",
            "max-md:gap-12",
            "max-md:items-start",
          )}
        >
          <h2
            className={clsx(
              "font-bold",
              "text-25",
              "max-md:text-left",
              "max-md:text-15",
              "max-w-650",
              "line-clamp-2",
            )}
          >
            {post.title}
          </h2>
          <div className={clsx("pb-4")}>
            <PostActionList
              post={post}
            ></PostActionList>
          </div>
        </div>
        <div
          className={clsx(
            "flex",
            "items-center",
            "gap-20",
            "pc_only_flex",
          )}
        >
          <div
            className={clsx("w-80", "mx-auto")}
          >
            <Link to={`/user/${post.user_id}`}>
              <UserIcon
                iconPath={post.user.iconurl ?? ""}
              />
            </Link>
          </div>
          <div
            className={clsx("pb-0", "pc_only")}
          >
            <h2
              className={clsx(
                "font-bold",
                "text-15",
              )}
            >
              {convertName(post.user.name)}
            </h2>
            {post.user &&
              !isNeverSns(post.user) && (
                <div
                  className={clsx(
                    "flex",
                    "items-center",
                    "gap-13",
                    "mt-10",
                  )}
                >
                  <UserSnsList
                    user={post.user}
                  ></UserSnsList>
                </div>
              )}
          </div>
        </div>
      </div>
    </m.div>
  );
};

export default PostBottomSticky;
